import styled from "styled-components"; 

const MentorStyleWrapper = styled.section`
  background: #090A1A;
    padding-top: 0px;
    padding-bottom: 105px;

  .section_title {
    text-align: center;
    margin-bottom: 55px;
  }
`;

export default MentorStyleWrapper;
